import { render, staticRenderFns } from "./shared-notes.html?vue&type=template&id=7d2e5ec9&scoped=true&"
import script from "./shared-notes.js?vue&type=script&lang=js&"
export * from "./shared-notes.js?vue&type=script&lang=js&"
import style0 from "./shared-notes.scss?vue&type=style&index=0&id=7d2e5ec9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e5ec9",
  null
  
)

export default component.exports